module.exports = __webpack_public_path__ + "portal-static/img/5.3963fb3e.jpg";